var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0264 14.9182L10.0344 14.9229C11.4929 15.8515 13.4007 15.6422 14.6232 14.4196L15.1392 13.9037C15.619 13.4233 15.619 12.645 15.1392 12.1646L12.9654 9.99214C12.485 9.51232 11.7067 9.51232 11.2263 9.99214V9.99214C10.9958 10.2229 10.6831 10.3525 10.357 10.3525C10.031 10.3525 9.71824 10.2229 9.48781 9.99214L6.00955 6.51321C5.52972 6.03279 5.52972 5.2545 6.00955 4.77408V4.77408C6.24027 4.54364 6.36991 4.23093 6.36991 3.90485C6.36991 3.57876 6.24027 3.26605 6.00955 3.03561L3.83646 0.859866C3.35604 0.380045 2.57776 0.380045 2.09733 0.859866L1.58139 1.37581C0.359058 2.59843 0.149585 4.50585 1.07745 5.96461L1.08278 5.97261C3.46478 9.49875 6.5008 12.5354 10.0264 14.9182V14.9182Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.4e582989cb60c8cc666df27de9c2107c.svg";
export { ForwardRef as ReactComponent };